import { render, staticRenderFns } from "./finalVersionCaseList.vue?vue&type=template&id=44ac46e8&scoped=true"
import script from "./finalVersionCaseList.vue?vue&type=script&lang=js"
export * from "./finalVersionCaseList.vue?vue&type=script&lang=js"
import style0 from "./finalVersionCaseList.vue?vue&type=style&index=0&id=44ac46e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ac46e8",
  null
  
)

export default component.exports